import * as React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { TableHead, TableRow, TableCell, Checkbox, TableSortLabel } from '@mui/material';
import { DataType } from './index';

const useStyles = makeStyles()((theme) => ({
    headRow: {
        backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        '& th': {
            fontWeight: 700,
            fontSize: '0.875rem',
            color: theme.palette.text.primary,
        },
    },
    sortLabel: {
        '&.Mui-active': {
            color: theme.palette.primary.main,
            '& .MuiTableSortLabel-icon': {
                color: theme.palette.primary.main,
                opacity: 1,
            },
        },
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

CustomTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

export default function CustomTableHead(props) {
    const { classes } = useStyles();
    const {
        order, orderBy, onRequestSort, onSelectAllClick, numSelected, rowCount,
        selectable, rowActions, headers
    } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow className={classes.headRow}>
                {selectable ?
                    <TableCell padding="checkbox" sx={{ backgroundColor: 'inherit' }}>
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{ 'aria-label': 'Seleccionar todos los registros' }}
                            color="primary"
                        />
                    </TableCell> : null}

                {rowActions && rowActions.length > 0 ?
                    <TableCell align="center" padding="normal" sx={{ backgroundColor: 'inherit', width: 56 }} aria-label="Acciones">
                        <span style={{ fontSize: '0.75rem', fontWeight: 600 }}>Acciones</span>
                    </TableCell> : null}

                {headers.map((header) => (
                    <TableCell
                        key={header.id}
                        align={header.align}
                        padding={header.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === header.id ? order : false}
                        sx={{ backgroundColor: 'inherit' }}
                    >
                        {header.sortable ?
                            <TableSortLabel
                                active={orderBy === header.id}
                                direction={order === "asc" ? "desc" : 'asc'}
                                onClick={createSortHandler(header.id)}
                                className={classes.sortLabel}
                                aria-label={`Ordenar por ${header.label}, ${orderBy === header.id ? (order === 'desc' ? 'orden descendente' : 'orden ascendente') : 'clic para ordenar'}`}
                            >
                                {header.label}
                                {orderBy === header.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'Orden descendente' : 'Orden ascendente'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        :
                            header.label
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}